import { render, staticRenderFns } from "./sglVideos.vue?vue&type=template&id=5f439a54&scoped=true&"
import script from "./sglVideos.vue?vue&type=script&lang=js&"
export * from "./sglVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f439a54",
  null
  
)

export default component.exports